import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'ui-menu-list-item',
  imports: [NgIcon, NgClass],
  templateUrl: './menu-list-item.html',
})
export class MenuListItem {
  icon = input<string>();
  mode = input<'default' | 'destructive' | 'admin'>('default');
}
